export class DuplicatedPairingError extends Error {}
